export const MAX_CODE_LENGTH = 40;

/**
 * Validates a customer code
 * @param code the code to validate
 * @returns an array of problem messages
 */
export const validateCode = (code: string) => {
  const problems: string[] = [];
  if (code.length > MAX_CODE_LENGTH) {
    problems.push('Maximum 40 characters.');
  }

  return problems;
};
